import { render, staticRenderFns } from "./ChainStageDialog.vue?vue&type=template&id=6c587c44&scoped=true"
import script from "./ChainStageDialog.vue?vue&type=script&lang=js"
export * from "./ChainStageDialog.vue?vue&type=script&lang=js"
import style0 from "./ChainStageDialog.vue?vue&type=style&index=0&id=6c587c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c587c44",
  null
  
)

export default component.exports